import {
  ColorPickerProps as MantineColorPickerProps,
  ColorPicker as MantineColorPicker,
} from '@mantine/core';

export type ColorPickerProps = MantineColorPickerProps;

export const ColorPicker = MantineColorPicker;

ColorPicker.displayName = 'ColorPicker';
